import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { fetchDocumentCoverage } from '../services/templateAssignments';
import type { DocumentCoverageColumn } from '../types/templateAssignments.types';
import { templateAssignmentKeys } from './templateAssignmentKeys';

export const useDocumentCoverageQuery = (productIds: string[], enabled: boolean): DocumentCoverageColumn => {
  const query = useQuery({
    queryKey: templateAssignmentKeys.coverage(productIds),
    queryFn: () => fetchDocumentCoverage(productIds),
    enabled: enabled && productIds.length > 0,
  });
  const byProductId = useMemo(
    () => new Map((query.data ?? []).map((entry) => [entry.productId, entry])),
    [query.data],
  );

  if (query.isError) return { byProductId, status: 'error' };
  return { byProductId, status: query.isSuccess ? 'ready' : 'loading' };
};
